var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('router-view'),_c('UpdateModal',{attrs:{"visible":_vm.showUpdateModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }